import { HttpClient } from "../../adapters/httpClient";
import { FileSystem } from "../../adapters/fileSystem";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(httpClient: HttpClient, fs: FileSystem): Interactor {
  return ({ document, saveToDisk }) =>
    present(
      httpClient
        .download(document.uri)
        .then((file) => ({ document, file }))
        .then((res) =>
          saveToDisk
            ? fs
                .writeDocumentToDisk({ ...res.document, uri: res.file.uri })
                .then(() => res)
            : res,
        )
        .catch(() => Promise.reject({ document, saveToDisk })),
    );
}

export type { Interactor };

export { createInteractor };
